import { Route, Routes } from "react-router-dom";
import { CatalogSampleTypePage } from "./CatalogSampleTypePage";

type Props = {};
const CatalogSampleType = (props: Props) => {
  return (
    <Routes>
      <Route index element={<CatalogSampleTypePage />}></Route>
      <Route path=":sampleTypeId" element={<CatalogSampleTypePage />}></Route>
    </Routes>
  );
};
export default CatalogSampleType;
